// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
// _mock
import { _socials } from 'src/_mock';
// components
import Logo from 'src/components/logo';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { IVORYPhotoStudioAr, IVORYPhotoStudioEn } from 'src/constants/companyinfo';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'IVORY Photo Studio',
    headlineAr: 'استوديو آيفوري',
    children: [
      { name: 'About us', nameAr: 'من نحن', href: paths.about },
      { name: 'Contact us', nameAr: 'تواصل معنا', href: paths.contact },
      {
        name: '9GPF+J9 Marina, Twin Towers B, 26th Floor, Lusail',
        nameAr: '٩ جي بي اف + ج ٩ مارينا، توين تاورز ب، الطابق ٢٦، لوسيل',
        href: '#',
      },
      // { name: 'P.O. Box : 38661 Doha, Qatar', nameAr: 'صندوق البريد : ٣٨٦٦١ الدوحة ٫ قطر' },
      // { name: 'FAQs', href: paths.faqs },
    ],
  },
  // {
  //   headline: 'Legal',
  //   children: [
  //     { name: 'Terms and Condition', href: '#' },
  //     { name: 'Privacy Policy', href: '#' },
  //   ],
  // },
  {
    headline: 'Contact',
    headlineAr: 'التواصل',
    children: [
      { name: 'info@ivory.qa', nameAr: 'info@ivory.qa', href: 'mailto:info@ivory.qa' },
      { name: '66557135', nameAr: '66557135', href: 'tel:+97466557135' },
      { name: '66557135', nameAr: '66557135', href: 'tel:+97466557135' },
    ],
  },
];

// ----------------------------------------------------------------------

export default function Footer() {
  const { isRTL } = useLocales();
  return (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        // bgcolor: 'background.default',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
      }}
    >
      <Divider />

      <Container
        sx={{
          pt: 10,
          pb: 5,
          textAlign: { xs: 'center', md: 'unset' },
        }}
      >
        <Logo sx={{ mb: 3 }} />

        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
        >
          <Grid xs={8} md={3}>
            <Typography
              variant="body2"
              sx={{
                maxWidth: 270,
                mx: { xs: 'auto', md: 'unset' },
              }}
            >
              {isRTL
                ? IVORYPhotoStudioAr.companyProfile.closingStatement
                : IVORYPhotoStudioEn.companyProfile.closingStatement}
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mt: 3,
                mb: { xs: 5, md: 0 },
              }}
            >
              {_socials.map((social) => (
                <IconButton
                  key={social.name}
                  sx={{
                    '&:hover': {
                      bgcolor: alpha(social.color, 0.08),
                    },
                  }}
                  href={social.path}
                  target="_blank"
                >
                  <Iconify color={social.color} icon={social.icon} />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid xs={12} md={6}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }}>
              {LINKS.map((list) => (
                <Stack
                  key={list.headline}
                  spacing={2}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                  sx={{ width: 1 }}
                >
                  <Typography component="div" variant="overline">
                    {isRTL ? list.headlineAr : list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <Link
                      key={link.name}
                      component={RouterLink}
                      href={link.href}
                      color="inherit"
                      variant="body2"
                    >
                      {isRTL ? link.nameAr : link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ mt: 10 }}>
          IVORY Photo Studio © 2025. All rights reserved
        </Typography>
      </Container>
    </Box>
  );
}
